import React, { FC }                  from 'react';
import styled                         from 'styled-components';
import { RouteComponentProps }        from 'react-router-dom';
import { EInvoicePage }               from '@enums/invoiceManagement';
import { Header }                     from './components/Header';
import { InvoiceManagementContainer } from './containers/InvoiceManagementContainer';
import { EstimateInvoiceContainer }   from './containers/EstimateInvoiceContainer';
import { InvoiceHistoryContainer }    from './containers/InvoiceHistoryContainer';
import { DefaultPricingContainer }    from './containers/DefaultPricingContainer';
import { UseTaxContainer }            from './containers/UseTaxContainer';

const Wrapper = styled.div`
  padding: 20px 100px 0;
`;

interface IParams {
  id    : string;
  page  : EInvoicePage;
  subid : string;
}

const ESTIMATE_INVOICE_PAGES: EInvoicePage[] = [
  EInvoicePage.Current,
  EInvoicePage.OverThirtyDays,
  EInvoicePage.OverSixtyDays,
  EInvoicePage.OverNinetyDays,
  EInvoicePage.CurrentDue,
  EInvoicePage.PastDue,
  EInvoicePage.Monthly,
];

export const InvoiceManagementMainContainer: FC<RouteComponentProps<IParams>> = ({
  history: {
    push,
    location: { search },
  },
  match: {
    params: { page },
  },
}) => (
  <Wrapper>
    <Header
      push        = {push}
      currentPage = {page}
    />

    {page === EInvoicePage.Search && (
      <InvoiceManagementContainer push={push} />
    )}

    {ESTIMATE_INVOICE_PAGES.includes(page) && (
      <EstimateInvoiceContainer
        page        = {page}
        historyDate = {search?.substr(1)}
      />
    )}

    {page === EInvoicePage.InvoiceHistory && (
      <InvoiceHistoryContainer push={push} />
    )}

    {page === EInvoicePage.DefaultPricing && (
      <DefaultPricingContainer />
    )}

    {page === EInvoicePage.UseTax && (
      <UseTaxContainer />
    )}
  </Wrapper>
);
